'use strict';

import defaultTemplate from '../../core/default.html';
import subscriptionsEditTemplate from './subscriptions.edit.html';

import Subscriptions from './subscriptions.ctrl';

function SubscriptionsRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.subscriptions', {
      url: '/subscriptions',
      template: defaultTemplate
    })
    .state('main.subscriptions.edit', {
      url: '/edit?:tab&:from&:userId&:locationId&:userPlanId',
      template: subscriptionsEditTemplate,
      controller: 'SubscriptionsEditController as vm'
    });
}

export default angular
  .module('subscriptions.router', [
    Subscriptions
  ])
  .config(SubscriptionsRouter)
  .name;
